import DispatcherAddRequest from "../../api/raily/dispatcher/add/dispatcher-add.request";
import dispatcherApiService from "../../api/raily/dispatcher/dispatcher-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import DispatcherAddError from "./add/dispatcher-add-error";
import DispatcherAddParams from "./add/dispatcher-add-params";
import dispatcherAddRequestFactory from "./add/dispatcher-add-params.factory";

const add = async (
  params: DispatcherAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: DispatcherAddRequest =
    dispatcherAddRequestFactory.create(params);

  try {
    const response = await dispatcherApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | DispatcherAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const dispatcherService = {
  add,
};

export default dispatcherService;
